import React from 'react';

export const PageContentComponent = ({ children }: { children: React.ReactNode }) => (
  <div style={{ position: 'relative' }}>{children}</div>
);

export default PageContentComponent;
